<script setup lang="ts">
const { isOnline, offlineAt } = useNetwork();
</script>

<template>
  <div class="h-[100dvh] overflow-hidden">
    <Statusbar :is-connected="isOnline" :offline-at="offlineAt" />

    <Tabbar />

    <slot></slot>
  </div>
</template>
